import { createContext, useContext } from 'react';
import type { Workspace, User } from '../api/client';

interface WorkspaceContextValue {
  user: User;
  workspace: Workspace;
}

export const WorkspaceContext = createContext<WorkspaceContextValue | null>(null);

export function useWorkspaceContext(): WorkspaceContextValue {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) {
    throw new Error('useWorkspaceContext must be used inside <WorkspaceContext.Provider>');
  }
  return ctx;
}
